import React, { useState, useEffect } from 'react';
import { Drawer, Layout, Form, Button, Col, Row, Input, Select, Space, Table, PageHeader, Typography,Empty, Menu,Dropdown } from 'antd';
//Modal,Checkbox, suspendidos x login inactivo
import { DownOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import { obtdatos,obtcicloestad } from './DatosEsc';
import { Link } from "react-router-dom";
//import {VersionCifras} from './ToolsCed';
import ExportJsonExcel from 'js-export-excel';
import './estilosantd.css';
//import { AlternateEmailTwoTone } from '@material-ui/icons';

const { Option } = Select;
const { Content } = Layout;
const { Title } = Typography;

const nivelData = [
  {
    idtipoedu:'0',
    nivel:[]
  },
  {
    idtipoedu:'2',
    nivel:[{idniv:'0',niv:'Inicial'},{idniv:'1',niv:'Preescolar'},{idniv:'2',niv:'Primaria'},{idniv:'3',niv:'Secundaria'}]
  },
  {
    idtipoedu:'3',
    nivel:[{idniv:'31',niv:'Bachillerato (Plantel)'},{idniv:'32',niv:'Bachillerato (Escuela)'}]
  },
  {
    idtipoedu:'4',
    nivel:[{idniv:'41',niv:'Superior (Institución)'},{idniv:'42',niv:'Superior (Escuela)'}]
  },
  {
    idtipoedu:'5',
    nivel:[{idniv:'1',niv:'Formación para el trabajo'}]
  },
  {
    idtipoedu:'6',
    nivel:[{idniv:'61',niv:'CAM'},{idniv:'62',niv:'USAER'}]
  }
];

const subnivData=[
  {
    idtipoedu:'0',
    idniv:[],
    subnivel:[]
  },
  {
    idtipoedu:'2',
    idniv:'0',
    subnivel: [{idsubniv:'1',subniv:'Lactante y maternal'}, {idsubniv:'2',subniv:'Inicial indígena'}]
  },
  {
    idtipoedu:'2',
    idniv:'1',
    subnivel: [{idsubniv:'1',subniv:'General'},{idsubniv:'2',subniv:'Comunitario'},{idsubniv:'3',subniv:'Indígena'}]
  },
  {
    idtipoedu:'2',
    idniv:'2',
    subnivel: [{idsubniv:'1',subniv:'General'},{idsubniv:'2',subniv:'Comunitario'},{idsubniv:'3',subniv:'Indígena'}]
  },
  {
    idtipoedu:'2',
    idniv:'3',
    subnivel: [{idsubniv:'1',subniv:'General'},{idsubniv:'2',subniv:'Comunitario'},{idsubniv:'3',subniv:'Telesecundaria'},{idsubniv:'4',subniv:'Técnica'}]
  },
  {
    idtipoedu:'3',
    idniv:'30',
    subnivel: []
  },
  {
    idtipoedu:'3',
    idniv:'40',
    subnivel: [{idsubniv:'31',subniv:'General'},{idsubniv:'32',subniv:'Tecnológico'}]
  },
  {
    idtipoedu:'4',
    idniv:'40',
    subnivel: []
  },
  {
    idtipoedu:'4',
    idniv:'50',
    subnivel: []
  },
  {
    idtipoedu:'5',
    idniv:'1',
    subnivel: []
  },
  {
    idtipoedu:'6',
    idniv:'60',
    subnivel: []
  },
  {
    idtipoedu:'6',
    idniv:'61',
    subnivel: []
  }
];

var ciclocifras=[];
const CedEst=()=> {
  const [filterTable, setFilterTable] = useState(null);
  const [edoFiltro, setedoFiltro] = useState(false);
  //const [edoLogin,setedoLogin]=useState(false);
  const [formfiltro] = Form.useForm();
  //const [formlogin] = Form.useForm();
  const [ciclo, setCiclo]=useState('0');
  //const [fteciclo,setFteCiclo]=useState('');
  const [datosciclo,setDatosCiclo]=useState({version:'',corte:''});
  const [colalum,setColAlum]=useState(true);
  const showDrawerFiltro = () => {setedoFiltro(true);};
  const historicos = ciclocifras.map(item => {return <Menu.Item key={item.ciclo}>Inicio de Cursos {item.ciclo} - {parseInt(item.ciclo)+1}</Menu.Item>}); 
    
  const onFinDrawerFiltro = () => {
    setedoFiltro(false);
  };
  const onFinFiltro = async () => {
    const response = await obtdatos(
      {
        'cvect':formfiltro.getFieldValue('cvect'),
        'nomct':formfiltro.getFieldValue('nomct'),
        'sost':formfiltro.getFieldValue('sost'),
        'subsist':formfiltro.getFieldValue('subsist'),
        'nivel':formfiltro.getFieldValue('nivel'),
        'subnivel':formfiltro.getFieldValue('subnivel'),
        'mun':formfiltro.getFieldValue('mun'),
        'ciclo':ciclo
      }
    );
    if (response.status === 200) {
      if (Object.keys(response.data).length === 0){
        setFilterTable([]);
        setTipoedu('0');
      }else{
        setFilterTable(response.data);
      }
    }
  };
  const onFallaFiltro = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const renderPagination=(current, type, originalElement)=>{
    if (type === 'prev') {
      return <a className="table-prev" style={{padding:'1rem'}}>Anterior</a>;
    }
    if (type === 'next') {
      return <a className="table-next" style={{padding:'1rem'}}>Siguiente</a>;
    }
    return originalElement;
  };

  const showTotal = (total, range) => {
    return `Registros del ${range[0]} al ${range[1]} de un total de ${total}`
  };

  let columnas = [
    {
      title: '',
      width: '8%',
      dataIndex: 'cedula',
      render: (_, record) =>
      <Link to={"/ced/"+record.cvect+"/"+ciclo} target={"_blank"}>
        <Button type="primary">Cédula</Button>
      </Link>
    },
    {
      title:"Cvect",
      width:'8%',
      dataIndex: 'cvect',
      fixed: 'left',
      sortDirections: ['ascend', 'descend'],
      sorter: (a, b) => a.cvect.localeCompare(b.cvect),
    },
    { 
      title:"Nivel",
      width:'18%',
      dataIndex: 'nivel',
      sortDirections: ['ascend', 'descend'],
      sorter: (a, b) => a.nivel.localeCompare(b.nivel),
    },
    { 
      title:"Nombre",
      width:'40%',
      dataIndex: 'nomct',
      sortDirections: ['ascend', 'descend'],
      sorter: (a, b) => a.nomct.localeCompare(b.nomct),
    },
    { 
      title:"Sostenimiento",
      width:'18%',
      dataIndex: 'sost',
      sortDirections: ['ascend', 'descend'],
      sorter: (a, b) => a.sost.localeCompare(b.sost),
    },
    { 
      title:"Alumnos",
      width:'8%',
      dataIndex: 'alum',
      hidden: colalum,
      sortDirections: ['ascend', 'descend'],
      sorter: (a, b) => parseInt(a.alum) - parseInt(b.alum)
    }
  ].filter(item => !item.hidden);

  const clearData=async()=>{
    const response = await obtdatos({'ciclo':ciclo})
    if (response.status === 200) {
      setFilterTable(response.data);
    }
  };

  const obtenDataciclo = async (numciclo) => {
    const response = await obtdatos(
      {
      'cvect':formfiltro.getFieldValue('cvect'),
      'nomct':formfiltro.getFieldValue('nomct'),
      'sost':formfiltro.getFieldValue('sost'),
      'subsist':formfiltro.getFieldValue('subsist'),
      'nivel':formfiltro.getFieldValue('nivel'),
      'subnivel':formfiltro.getFieldValue('subnivel'),
      'mun':formfiltro.getFieldValue('mun'),
      'ciclo':numciclo
    })
    if (response.status === 200) {
      setFilterTable(response.data);
      let ftenumciclo=ciclocifras.find(element => element.ciclo===numciclo);
      if (ftenumciclo!==undefined){
        setCiclo(numciclo);
        //setFteCiclo(ftenumciclo.fuente);
        ActDatosCiclo(ftenumciclo.veredo,ftenumciclo.corteprelim);
        ColAlumTable(ftenumciclo.fuente);
      }
    }
  }

  const fetchData = async () => {
      const listaciclo = await obtcicloestad();
      if (listaciclo.status===200){
        ciclocifras=listaciclo.data;
        ActDatosCiclo(ciclocifras[0]['veredo'],ciclocifras[0]['corteprelim']);
        let ultciclo=ciclocifras[0]['ciclo'];
        let ultfteciclo=ciclocifras[0]['fuente'];
        const response = await obtdatos({'ciclo':ultciclo})
        if (response.status === 200) {
          ColAlumTable(ultfteciclo);
          setCiclo(ultciclo);
          //setFteCiclo(ultfteciclo);
          setFilterTable(response.data);
        };
      };      
  };
  
  const ColAlumTable=(fuente)=>{
    switch (fuente){
      case 'ESTADIS':
        setColAlum(false);
        break;
      case 'CONTROL':
        setColAlum(true);
        break;
      default:
        setColAlum(false);
    }    
  }

  const resetFiltro = () => {
    formfiltro.resetFields();
    clearData();
    setTipoedu('0');
  };

  const ActDatosCiclo=(edociclo,fechaedo)=>{
    if(edociclo==='AP'){
      setDatosCiclo({version:'Cifras Preliminares de ',corte:` (Corte ${fechaedo})`})
    }else{
      setDatosCiclo({version:'',corte:''})
    }
  }
  
  useEffect(() => {
    fetchData();
  }, []);  

  function exportaExcel() {
    const option = {};
    option.fileName = 'CedC911';
    option.datas = [
      {
        sheetData: filterTable.map(item => {
          const result = {};
          columnas.forEach(c => {
            if (c.dataIndex !== "cedula") {
              result[c.dataIndex] = item[c.dataIndex];
            }
          });
          return result;
        }),      
        sheetFilter: ['cvect', 'nivel', 'nomct', 'sost', colalum?'':'alum'],
        sheetHeader: ['cvect', 'nivel', 'nomct', 'sost', colalum?'':'alum'],        
        columnWidths: [6, 10, 15, 10, colalum?0:6],
      },
    ];
    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }
  
  function onClickCenso(e) {
    obtenDataciclo(e.key);
  }

  const menu = (
    <Menu onClick={onClickCenso}>
      {historicos}
    </Menu>
  );

  //const showLogin = () => {
    //setedoLogin(true);
  //};

  //const onFinLogin = (values) => {
    //setedoLogin(false);
  //};

/*   const onFallaLogin = (errorInfo) => {
    console.log('Failed:', errorInfo);
  }; */

  //const onCancelaLogin=() => {
    //setedoLogin(false);
  //}

  //const layout = {labelCol:{span: 8},wrapperCol:{span:16}};

  //const tailLayout = {wrapperCol:{offset:8,span: 16}};
{/*
  const contentlogin = (
    <Form
      form={formlogin}
      {...layout}
      name="basic"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinLogin}
      onFinishFailed={onFallaLogin}
    >
      <Form.Item
        label="Username"
        name="username"
        rules={[{required: true, message: 'Ingrese el usuario!' }]}
      >
        <Input/>
      </Form.Item>
      <Form.Item
        label="Password"
        name="password"
        rules={[{required: true, message: 'Ingrese la contraseña!'}]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item {...tailLayout} name="remember" valuePropName="checked">
        <Checkbox>Recuerdame</Checkbox>
      </Form.Item>
      <Space size={'large'} align={'center'}>
        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">Identificarse</Button>
        </Form.Item>
        <Form.Item {...tailLayout}>
            <Button type="primary" onClick={onCancelaLogin} style={{ marginRight: 8 }}>Cancelar</Button>
        </Form.Item>        
      </Space>
    </Form>
  );
  */}
  const [tipoedu, setTipoedu] = useState('0');
  const [nivedu, setNivedu] = useState(undefined);
  const [subnivedu, setSubnivedu] = useState(undefined);
  
  const handlesubsistChange = value => {
    if (value===undefined){
      formfiltro.setFieldsValue({"nivel": undefined});
      formfiltro.setFieldsValue({"subnivel": undefined});
      setTipoedu('0');
    }else{
      if (value==='5'){
        formfiltro.setFieldsValue({"nivel": '1'});
      }else {
        formfiltro.setFieldsValue({"nivel": undefined});
      }
      formfiltro.setFieldsValue({"subnivel": undefined});
      setTipoedu(value);
    }
  }
  const handlenivelChange = value => {
    if (value!==undefined){
      formfiltro.setFieldsValue({"subnivel": undefined});
      setNivedu(value);
    }
  };
  const handlesubnivelChange = value => {
    if (value!==undefined){
      setSubnivedu(value);
    }
  };
  const niveles = nivelData.find(item => item.idtipoedu === tipoedu)?.nivel.map((listaniv) => (
    <Option key={listaniv.idniv} value={listaniv.idniv} disabled={listaniv.niv==='Inicial'?colalum:false}>
      {listaniv.niv}
    </Option>
  ));
  const subniveles = subnivData.find(item => item.idtipoedu===tipoedu && item.idniv === nivedu)?.subnivel.map((listasubniv) => (
    <Option key={listasubniv.idsubniv} value={listasubniv.idsubniv} disabled={listasubniv.subniv==='Comunitario'?colalum:false}>
      {listasubniv.subniv}
    </Option>
  ));

function descripCiclo(){
  let rotulo='Inicio de Cursos';
  let periodo=parseInt(ciclo) + 1;
   if(ciclo!=='0'){
    rotulo=datosciclo.version + rotulo + ' ' + ciclo + ' - ' + periodo.toString() + datosciclo.corte;
  }
  return rotulo;
}
return (
  <>
    <Layout>
      <PageHeader>
        <Row id='r01'>
          <Title className='tituloced'>Centros de Trabajo que reportan Estadística Educativa</Title>
        </Row>
        <Row id='r02'>
          <Title className='subtituloced'>{descripCiclo()}</Title>
        </Row>
        <Row id='r03' align="middle">
          <Col flex="1 1 300px">
            <Space size={'large'}>
              <Button type="primary" 
                size={'large'} onClick={showDrawerFiltro}>Filtros
              </Button>
              <Button type="primary" 
                size={'large'} onClick={exportaExcel}>Excel
              </Button>
            </Space>
          </Col>
          <Col>
          <Dropdown overlay={menu}>
                <Button type="primary" size={'large'}>
                  Ciclos escolares <DownOutlined />
                </Button>
              </Dropdown>
          </Col>
          {/*
          <Col flex="0 1 240px">
            <Modal
              title="Login"
              width={320}
              style={{ top: 74, marginRight:38 }}
              visible={edoLogin}
              closable={false}
              footer={null}
            >
            {contentlogin}
            </Modal>
            <Button type="primary" size={'large'} onClick={showLogin}>Login</Button>
          </Col>
          */}
        </Row>
      </PageHeader>
      <Content className="site-layout" style={{ padding: '0% 1% 0% 1%' }}>
        <Table id='resumen' rowKey="key" columns={columnas} dataSource={filterTable}
          locale={{emptyText: <Empty image={false} description={<h4>Datos inexistentes</h4>}/>}}
          showSorterTooltip={{ title: 'Clic para ordenar' }}
          sticky
          /* scroll={{ x: 400, y: 560 } } */
          scroll={{ x: 400, y: "67vh" } }
          size={'small'}
          className={'ant-table-content'}
          pagination={{
            simple:false,
            showTotal: showTotal,
            itemRender:(current, type, originalElement)=>renderPagination(current, type, originalElement),
            showQuickJumper: false,
            pageSize: 20,
            pageSizeOptions: ['20', '30', '50', '100'],
            showSizeChanger: false,
            hideOnSinglePage: true
          }}
        />
      </Content>
    </Layout>
    <Drawer title="Filtros" width={300} placement={"left"} closable={true} onClose={onFinDrawerFiltro} visible={edoFiltro}>
      <Form layout="vertical"
        form={formfiltro}
        hideRequiredMark
        name="formulario"
        initialValues={{remember: true}}
        onFinish={onFinFiltro}
        onFinishFailed={onFallaFiltro}
        >
        <Row id='r10' gutter={0} marginbottom={12}>
          <Col span={16}>
            <Form.Item name="cvect" label="Clave" >
              <Input placeholder="Clave del centro de educativo" allowClear/>
            </Form.Item>
          </Col>
        </Row>
        <Row id='r20' gutter={0}>
          <Col span={24}>
            <Form.Item name="nomct" label="Nombre de centro educativo">
              <Input placeholder="Nombre del centro de educativo" allowClear/>
            </Form.Item>
          </Col>
        </Row>
        <Row id='r30' gutter={0}>
          <Col span={24}>
            <Form.Item name="sost" label="Sostenimiento" >
              <Select placeholder="Seleccione un sostenimiento" allowClear>
                <Option value="ESTATAL">Estatal</Option>
                <Option value="FEDERAL">Federal</Option>
                <Option value="FEDERAL TRANSFERIDO">Federal transferido</Option>
                <Option value="FEDERAL TRANSFERIDO-ESTATAL">Federal transferido-estatal</Option>
                <Option value="PRIVADO">Privado</Option>
                <Option value="SUBSIDIO">Subsidio</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row id='r40' gutter={0}>
          <Col span={24}>
            <Form.Item name="subsist" label="Tipo educativo">
              <Select placeholder="Seleccione un tipo educativo" allowClear value={nivedu} onChange={handlesubsistChange}>
                <Option key="2" value="2">Educación básica</Option>
                <Option key="3" value="3" disabled={colalum}>Media superior</Option>
                <Option key="4" value="4" disabled={colalum}>Superior</Option>
                <Option key="6" value="6" disabled={colalum}>Especial</Option>
                <Option key="5" value="5" disabled={colalum}>Capacitación</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row id='r50' gutter={0}>
          <Col span={24}>
            <Form.Item name="nivel" label="Nivel">
              <Select placeholder="Seleccione un nivel" allowClear value={nivedu} onChange={handlenivelChange} notFoundContent={"Elija un tipo educativo"}>
                {niveles}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row id='r60' gutter={0}>
          <Col span={24}>
            <Form.Item name="subnivel" label="SubNivel">
              <Select name="subnivel" placeholder="Seleccione un subnivel" allowClear value={subnivedu} onChange={handlesubnivelChange} notFoundContent={"Elija un nivel"}>
                {subniveles}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row id='r70' gutter={0}>
          <Col span={24}>
            <Form.Item
              name="mun"
              label="Municipio"
            >
              <Select placeholder="Seleccione un municipio" allowClear>
                <Option value="001">Balancán</Option>
                <Option value="002">Cárdenas</Option>
                <Option value="003">Centla</Option>
                <Option value="004">Centro</Option>
                <Option value="005">Comalcalco</Option>
                <Option value="006">Cunduacán</Option>
                <Option value="007">Emiliano Zapata</Option>
                <Option value="008">Huimanguillo</Option>
                <Option value="009">Jalapa</Option>
                <Option value="010">Jalpa de Méndez</Option>
                <Option value="011">Jonuta</Option>
                <Option value="012">Macuspana</Option>
                <Option value="013">Nacajuca</Option>
                <Option value="014">Paraíso</Option>
                <Option value="015">Tacotalpa</Option>                  
                <Option value="016">Teapa</Option>
                <Option value="017">Tenosique</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
            <div id="capfiltro"
              style={{
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
              }}
            >
              <Button type="primary" onClick={resetFiltro} style={{ marginRight: 8 }}>Limpiar</Button>
              <Button type="primary" htmlType="submit">Aplicar</Button>
            </div>
      </Form>
    </Drawer>
  </>
    )
  }

export default CedEst;